<template>
  <article class="description_video_container">
    <h3 class="wow fadeInUp">{{ title }}</h3>
    <section class="container wow fadeInUp">
      <iframe
        loading="lazy"
        :src="videoSrc"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </section>
  </article>
</template>

<script>
export default {
  name: "ProjectPageVideoContainer",
  props: ["title", "videoSrc"],
};
</script>
